import './_empty-services.scss';
import React from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ReactComponent as Empty } from './empty.svg';
import { ReactComponent as EmptyDarkMode } from './empty-dark-mode.svg';
import { openModal } from '../../../../reducer';
import { MODALS } from '../../../../constants';

const TableEmptySearch = ({ serviceDispatch }) => {
  const { config } = useSelector((state) => state.services);
  const { darkMode } = useSelector((state) => state.general);

  const showAddServices = config?.access?.import_services;
  const showImportServices = config?.access?.edit_services;

  const onAddService = () => {
    serviceDispatch(openModal(MODALS.EDIT_SERVICE, null))
  };

  const onImportServices = () => {
    serviceDispatch(openModal(MODALS.EDIT_SERVICE, null))
  }

  return (
    <div className="service-table__empty-services">
      <div>
        <div className="service-table__empty-services-icon">
          {darkMode ? <EmptyDarkMode /> : <Empty /> }
        </div>
        <div className="service-table__empty-services-description">
          <div>You don't have any services yet.</div>
          {showAddServices || showImportServices ? <div>Add the service manual or import using the provider.</div> : null }
        </div>
        {showAddServices || showImportServices
          ? (
            <div className="service-table__empty-services-actions">
              {showAddServices ? <Button onClick={onAddService}>Add service</Button> : null }
              {showImportServices ? <Button bsStyle="primary" onClick={onImportServices}>Import</Button> : null }
            </div>
          ) : null}
      </div>
    </div>
  )
}

TableEmptySearch.propTypes = {
  serviceDispatch: PropTypes.func,
}

export default TableEmptySearch;
